import type { HsShader } from '../shaders/classes/shader.class';
import { HsDefaultMaterial } from './default-material.class';

export class HsPointsMaterial<T extends HsShader> extends HsDefaultMaterial<T> {
  public setPointSize(gl: WebGL2RenderingContext, size: number): void {
    this.getShader().uniform1f(gl, 'u_pointSize', size);
  }
}
